/* eslint-disable react/prop-types */
// Dashboard React components
import DSBox from "components/DSBox";
import DSTypography from "components/DSTypography";
import DSAvatar from "components/DSAvatar";
import DSBadge from "components/DSBadge";

// Images
import team1 from "assets/images/team-1.jpg";
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

function Author({ image, name, email }) {
  return (
    <DSBox display="flex" alignItems="center" px={1} py={0.5}>
      <DSBox mr={2}>
        <DSAvatar src={image} alt={name} size="sm" variant="rounded" />
      </DSBox>
      <DSBox display="flex" flexDirection="column">
        <DSTypography variant="button" fontWeight="medium">
          {name}
        </DSTypography>
        <DSTypography variant="caption" textColor="secondary">
          {email}
        </DSTypography>
      </DSBox>
    </DSBox>
  );
}

function Function({ job, org }) {
  return (
    <DSBox display="flex" flexDirection="column">
      <DSTypography variant="caption" fontWeight="medium" textColor="text">
        {job}
      </DSTypography>
      <DSTypography variant="caption" textColor="secondary">
        {org}
      </DSTypography>
    </DSBox>
  );
}

export default {
  columns: [
    { name: "employee", align: "left" },
    { name: "function", align: "left" },
    { name: "status", align: "center" },
    { name: "employed", align: "center" },
    { name: "action", align: "center" },
  ],

  rows: [
    {
      employee: <Author image={team2} name="Arthur Grimes" email="agrimes@dspl.com" />,
      function: <Function job="Director" org="Sales" />,
      status: (
        <DSBadge variant="gradient" badgeContent="online" color="success" size="extra-small" />
      ),
      employed: (
        <DSTypography variant="caption" textColor="secondary" fontWeight="medium">
          05-22-2018
        </DSTypography>
      ),
      action: (
        <DSTypography
          component="a"
          href="#"
          variant="caption"
          textColor="secondary"
          fontWeight="medium"
        >
          Edit
        </DSTypography>
      ),
    },
    {
      employee: <Author image={team1} name="Doreen Michaels" email="dmichaels@dspl.com" />,
      function: <Function job="Executive" org="Sales" />,
      status: (
        <DSBadge variant="gradient" badgeContent="offline" color="secondary" size="extra-small" />
      ),
      employed: (
        <DSTypography variant="caption" textColor="secondary" fontWeight="medium">
          02-12-2021
        </DSTypography>
      ),
      action: (
        <DSTypography
          component="a"
          href="#"
          variant="caption"
          textColor="secondary"
          fontWeight="medium"
        >
          Edit
        </DSTypography>
      ),
    },
    {
      employee: <Author image={team1} name="Victoria Laim" email="vlaim@dspl.com" />,
      function: <Function job="Executive" org="Marketing" />,
      status: (
        <DSBadge variant="gradient" badgeContent="online" color="success" size="extra-small" />
      ),
      employed: (
        <DSTypography variant="caption" textColor="secondary" fontWeight="medium">
          08-05-2021
        </DSTypography>
      ),
      action: (
        <DSTypography
          component="a"
          href="#"
          variant="caption"
          textColor="secondary"
          fontWeight="medium"
        >
          Edit
        </DSTypography>
      ),
    },
    {
      employee: <Author image={team2} name="Michael Newman" email="michael@dspl.com" />,
      function: <Function job="Manager" org="Marketing" />,
      status: (
        <DSBadge variant="gradient" badgeContent="online" color="success" size="extra-small" />
      ),
      employed: (
        <DSTypography variant="caption" textColor="secondary" fontWeight="medium">
          04-22-2016
        </DSTypography>
      ),
      action: (
        <DSTypography
          component="a"
          href="#"
          variant="caption"
          textColor="secondary"
          fontWeight="medium"
        >
          Edit
        </DSTypography>
      ),
    },
    {
      employee: <Author image={team3} name="Gary Gran" email="garyg@dspl.com" />,
      function: <Function job="Manager" org="Sales" />,
      status: (
        <DSBadge variant="gradient" badgeContent="offline" color="secondary" size="extra-small" />
      ),
      employed: (
        <DSTypography variant="caption" textColor="secondary" fontWeight="medium">
          07-09-2018
        </DSTypography>
      ),
      action: (
        <DSTypography
          component="a"
          href="#"
          variant="caption"
          textColor="secondary"
          fontWeight="medium"
        >
          Edit
        </DSTypography>
      ),
    },
    
  ],
};
